import React, { useState } from 'react';

import s from "./Layout.module.css"
import Reports from '../Reports/Reports';
import LogsReport from './LogsReport';


export default function LayoutReports() {

    const [activeComponent, setActiveComponent] = useState('Reports');

    const handleLogsClick = () => {
        setActiveComponent('Logs');
    };

    const handleBackClick = () => {
        setActiveComponent('Reports');
    };

    return (
        
            <div className={s.container}>
                <div className={s.content}>
                    {activeComponent === 'Reports' ? (
                        <Reports handleLogsClick={handleLogsClick} />
                    ) : activeComponent === 'Logs' ? (
                        <LogsReport handleBackClick={handleBackClick} />
                    ) : (null)}
                </div>
            </div>

    )
}